import React, { Fragment, useContext } from 'react';
import { BlockIdContext } from '../context/blockIdContext';
import { InnerContext } from '../context/innerContext';
import { getBlockIndexFromId } from '../utils';
export const BlockDecoration = (props) => {
    var _a, _b;
    const blockContenxtId = getBlockIndexFromId(useContext(BlockIdContext));
    const { headerBlockTypes } = useContext(InnerContext);
    const blockId = props.id || blockContenxtId;
    const isHeader = Boolean(props.id && headerBlockTypes.includes(props.id));
    const block = React.createElement(Fragment, null, props.children);
    const blockDecorators = (_b = (_a = useContext(InnerContext).customization) === null || _a === void 0 ? void 0 : _a.decorators) === null || _b === void 0 ? void 0 : _b.block;
    if (!blockDecorators) {
        return block;
    }
    return blockDecorators.reduce((children, decorator) => (React.createElement(Fragment, null, decorator({ children, id: blockId, isHeader }))), block);
};
